export function isIos() {
    return navigator.userAgent.match(/iPad|iPhone|iPod/)
}
export function isAndroid() {
    return navigator.userAgent.match(/Android/)
}